import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as d, normalizeClass as o, createElementVNode as s } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconShortcuts",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.647 1.147a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .707l-2.5 2.5a.5.5 0 0 1-.707-.707L9.293 4.5H4A1.5 1.5 0 0 0 2.5 6v1a.5.5 0 1 1-1 0V6A2.5 2.5 0 0 1 4 3.5h5.293L7.647 1.854a.5.5 0 0 1 0-.707ZM1 9.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
  "clip-rule": "evenodd"
}, null, -1), u = [
  _
];
function m(e, h, r, f, p, a) {
  return d(), i("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--shortcuts"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Shortcuts",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, u, 10, c);
}
const g = /* @__PURE__ */ l(n, [["render", m]]);
export {
  g as default
};
//# sourceMappingURL=shortcuts.js.map
